var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C0.447715 2 0 2.44771 0 3V9.96896C0 10.5212 0.447716 10.969 1 10.969H15.1039C15.6562 10.969 16.1039 10.5212 16.1039 9.96896V3C16.1039 2.44772 15.6562 2 15.1039 2H1ZM1.57324 3.12112C1.2971 3.12112 1.07324 3.34498 1.07324 3.62112V9.34784C1.07324 9.62398 1.2971 9.84784 1.57324 9.84784H14.53C14.8061 9.84784 15.03 9.62398 15.03 9.34784V3.62112C15.03 3.34498 14.8061 3.12112 14.53 3.12112H1.57324ZM2.14746 6.48448L4.29465 4.24224V8.72672L2.14746 6.48448ZM2.56152 11.6032L2.58727 11.5293H3.74648C3.72761 11.7525 3.85813 11.9723 4.07576 12.055L16.256 16.6845C16.5142 16.7826 16.7971 16.6508 16.888 16.39L18.762 11.0132C18.8529 10.7525 18.7173 10.4616 18.4592 10.3635L16.6411 9.67243V8.47938L19.3679 9.5158C19.8841 9.71202 20.1553 10.2939 19.9735 10.8154L17.6943 17.3549C17.5125 17.8764 16.9466 18.1401 16.4304 17.9439L3.16715 12.9028C2.6509 12.7065 2.37975 12.1247 2.56152 11.6032Z",
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendtag);
export default __webpack_public_path__ + "static/media/sendtag.5d0f6d7a4a022755f17ac7b9076cdd0c.svg";
export { ForwardRef as ReactComponent };